<div class="date_by">
    <ng-container *ngIf="LeftText">{{LeftText}} </ng-container>
    <ng-container *ngIf="ShowDate">{{Date | smDate:Format}}</ng-container>
    <ng-container *ngIf="ShowDate && ( ShowUserBadge || ShowUserName )"> by</ng-container>
    <sm-avatar *ngIf="ShowUserBadge" [model]="User" size="small"></sm-avatar> 
    <ng-container *ngIf="ShowUserName"> {{User.Name}}</ng-container>
</div>